var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13C8.76142 13 11 10.7614 11 8C11 5.23858 8.76142 3 6 3C3.23858 3 1 5.23858 1 8C1 10.7614 3.23858 13 6 13ZM5.25 10.25C5.25 9.83579 5.58579 9.5 6 9.5C6.41421 9.5 6.75 9.83579 6.75 10.25C6.75 10.6642 6.41421 11 6 11C5.58579 11 5.25 10.6642 5.25 10.25ZM5.50806 5.41012C5.55039 5.17688 5.75454 5 6 5C6.24546 5 6.44961 5.17688 6.49194 5.41012L6.5 5.5V8L6.49194 8.08988C6.44961 8.32312 6.24546 8.5 6 8.5C5.75454 8.5 5.55039 8.32312 5.50806 8.08988L5.5 8V5.5L5.50806 5.41012Z",
    fill: "#B10E1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.b1a1240c52aa19ad5cf644c81510d37d.svg";
export { ForwardRef as ReactComponent };